export const NO_DATA_ERROR = "NO_DATA";
